<mat-form-field>
	<input matInput placeholder="Lieu" [matAutocomplete]="auto" [formControl]="search">
</mat-form-field>

<mat-autocomplete #auto="matAutocomplete">
	<mat-option *ngFor="let option of options" [value]="option">
		{{ option.name }}
	</mat-option>
</mat-autocomplete>
